import { CrudStoreItemPartner360 } from 'legacy/lut/classes/models/partner360/CrudStoreItemPartner360'
import { IBridge } from 'legacy/lut/classes/models/partner360/IBridge'

import { Crud } from 'core/types/Crud'
import { CrudStore } from 'core/types/crudStore'

export const getBusinessBridgeCrud = () =>
  CrudStore.get(CrudStoreItemPartner360.JBPBusinessBridges, 'bridges-JBPBridges') as Crud<IBridge>
